"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ikon = _interopRequireDefault(require("./ikon"));
const ArrowDown = _ref => {
  let {
    title = 'Down Arrow',
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, props, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.875 13.094l6.125 6.125 6.125-6.125 1.875 1.875-8 8-8-8z"
  }));
};
var _default = exports.default = (0, _ikon.default)(ArrowDown);
ArrowDown.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ArrowDown",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Down Arrow'",
        "computed": false
      },
      "required": false
    }
  }
};